SP.VariantImageSwitcher = Garnish.Base.extend({
    $el: null,

    id: null,
    hasImage: false,
    targetIdPrefix: '#variant-image-',

    init(el) {
        this.$el = $(el)
        this.id = this.$el.data('id')
        this.hasImage = this.$el.data('image')

        if (this.hasImage) {
            this.addListener(this.$el, 'mouseenter', this.showVariantImage)
            this.addListener(this.$el, 'mouseleave', this.hideVariantImage)
        }
    },

    showVariantImage() {
        let target = this.targetIdPrefix + this.id
        $(target).addClass('show')
    },

    hideVariantImage() {
        let target = this.targetIdPrefix + this.id

        $(target).removeClass('show')
    }
})